class CityType {
  /**
   * @param {Object} data
   * @param {number} data.id
   * @param {string} data.name
   * @param {string} data.shortName
   */
  constructor({id, name, shortName}) {
    /** @type {number} */
    this.id = id;
    /** @type {string} */
    this.name = name;
    /** @type {string} */
    this.shortName = shortName;
  }
}

export default CityType;